import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { ActionSelect } from '../../../Action'
import { useEmailProfileContext } from '../../Email.hooks'

import { getActions } from './EmailProfileActionsWidgetServiceRequestButton.utils'

import ServiceRequestIcon from '../../../../icons/service-request.svg'

function EmailProfileActionsWidgetServiceRequestButton({
  dropdownPlacement = FLOATING_ELEMENT_PLACEMENT.bottom,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  onClick,
}) {
  const { t } = useTranslation()

  const { entityData } = useEmailProfileContext()

  const actions = getActions({ permissions: entityData.permissions, t })

  return (
    <ActionSelect
      actions={actions}
      controlProps={{
        buttonProps: {
          beforeIconProps: { Icon: ServiceRequestIcon },
          tooltip: t('EmailProfile.ActionsWidgetServiceRequestsTooltipKey'),
          tooltipPlacement,
        },
      }}
      dropdownFloatingConfig={{
        placement: dropdownPlacement,
      }}
      onClickAction={onClick}
    />
  )
}

export default EmailProfileActionsWidgetServiceRequestButton
